<fhm-status-panel [title]="'Menu'" [status]="Status.NONE">
  <fui-rows>
    @if (!UserData.isSalesManager(loggedUser)) {
      <fui-row>
        <fhm-action-buttons>
          <fui-commands [title]="'Upload Menu'" [showPopupForSingleItems]="false">
            <fui-command (clicked$)="uploadMenu()"></fui-command>
          </fui-commands>
        </fhm-action-buttons>
        <input #inputUploadFile class="input-upload-file" type="file" (click)="inputUploadContractClick($event)"
          (change)="fileSelected($event)">
      </fui-row>
    }
    @for (menu of model.data.menus; track menu) {
      <fui-row>
        {{menu.fileName}}
        <fui-link-button class="action" [title]="'download'"
        (click)="downloadMenu(menu)"></fui-link-button>
        <fui-link-button class="action" [title]="'delete'"
        (click)="deleteMenu(menu)"></fui-link-button>
      </fui-row>
    }
  </fui-rows>
</fhm-status-panel>
